import React, { ReactElement } from 'react';

import { SidebarContentBlock } from 'api/cms';
import { PublicPage } from 'api/website';
import { mapContentBlock } from 'cms/mappers';

type Props = {
  content: PublicPage;
  block: SidebarContentBlock;
  index: number;
};

export function ContentPageSidebarBlockComponent({
  content,
  block,
  index,
}: Props): ReactElement {
  const { component } = mapContentBlock({
    content,
    block,
    index,
    anchor: undefined,
    isPageHeader: false,
    offsetAnchors: false,
    isSidebar: true,
  });

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{component}</>;
}
